import React, { Component } from "react";
import { connect } from "react-redux";
import history from "../../../Utils/History";
import PlanCard from "./PlanCard";
import {
  getAgentIDListInPreEnrollForm,
  setFormData,
  getPlanDetails,
  planSelectionContinue,
  yearSelection,
  setStateParams,
  getPlans,
  sendEmail,
  getZipCodes,
} from "../../../Redux/Actions/webAppActions";
import PlanNotFound from "./PlanNotFound";
import SortBy from "./SortBy";
class PlanList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comparePlans: this.props.compareList,
      cardData: this.props.cardDetails,
      matchFound: true,
      disablePlan: false,
      clicked: false,
      value:
        this.props.deeplink === true
          ? this.props.dpzipCode
          : this.props.zipCode,
      planNotAvailable: false,
      zipCode: this.props.zipCode,
      sortingVal: "",
    };
  }

  componentDidMount() {
    this.setState({
      clicked: false,
    });
  }

  componentWillMount(){
    this.setState({
      cardData:this.props.cardDetails
    });
  }

  handleSelect = async (
    event,
    planId,
    planName,
    productName,
    productId,
    premiumAmount,
    productCategory,
    pbpId
  ) => {
    event.preventDefault();
    this.props.setStateParams("product", productName.trim());
    let planSelected = {
      planId: planId,
      pbpId: pbpId,
    };
    this.props.setStateParams("planSelected", planSelected);
    let formPayload = {
      planId: planId,
      planName: planName,
      plan: planId,
      productId: productId,
      productCategory: productCategory ? productCategory : "",
    };
    this.props.setFormData({
      ...formPayload,
      productName: productName,
      productId: productId,
      premiumAmount: premiumAmount,
    });
    let payload = {
      planId: planId,
      customerId: this.props?.customerId,
      productId: productId,
      premiumAmount: premiumAmount,
    };
    let plnType = this.props.cardDetails.filter(
      (x) => x.productId === productId
    )[0].planType;
    let response = await this.props.planSelectionContinue(
      payload,
      this.props?.customerId
    );
    if (response.status === "OK") {
      // await this.props.getAgentIDListInPreEnrollForm(this.props?.customerId);  //commented as it is not required for Sharp
      //this.props.setStateParams("selectedPlanDetails", payload);
      window.sessionStorage.setItem("planName", this.props.selectedPlanName);

      window.sessionStorage.setItem(
        "selectedPlanDetails",
        JSON.stringify(payload)
      );
      if (this.props?.prospectEnroll !== true) {
        this.props.setStateParams("isUpdated", false);
        await this.props.setStateParams("appNum", null);
        await this.props.setStateParams("guestbeneagentAppNum", null);
        await this.props.setStateParams("pendingApplFlag", false);
      }
      // if(this.props?.prospectEnroll===true && this.props?.appNum){

      // }
      await this.props.setStateParams("planType", plnType);
      await this.props.setStateParams("selectedVo", []);
      this.props.setStateParams("selectedIndex", null);
      history.push("/e-Enroll/enrollOnline");
    }
  };
  static getDerivedStateFromProps(nextProps, state) {
    let compareLists = state.comparePlans;
    let disablePlans = state.disablePlan;
    if (state.comparePlans != nextProps.compareList) {
      compareLists = nextProps.compareList;
      disablePlans = false;
    }

    //console.log("dfsdfsfdsg dfsgs",state.cardDataUpdated)
    let temp = nextProps.cardDetails;

    if (
      nextProps.planTypeFilter !== "" ||
      nextProps.productFilter !== "" ||
      nextProps.premiumFilter !== ""
    ) {
      let newCardData = [];
      const planType = nextProps.planTypeFilter;
      const productType = nextProps.productFilter;
      const premiumType =
        nextProps.premiumFilter !== "" ? parseInt(nextProps.premiumFilter) : "";
      if (
        nextProps.planTypeFilter !== "" &&
        nextProps.productFilter !== "" &&
        nextProps.premiumFilter
      ) {
        newCardData = temp.filter(
          (current, i) =>
            temp[i].type.includes(planType) &&
            productType === temp[i].productName.trim() &&
            parseInt(temp[i].monthlyPremium) <= premiumType
        );
        if (state.sortingVal && state.sortingVal !== "") {
          newCardData = newCardData.sort((a, b) => {
            const aPrice =
              state.dataId && Number(a[state.dataId].replace(/[^0-9.-]+/g, ""));
            const bPrice =
              state.dataId && Number(b[state.dataId].replace(/[^0-9.-]+/g, ""));
            if (state.sortingVal === "HTL") {
              return bPrice - aPrice;
            } else {
              return aPrice - bPrice;
            }
          });
        }

        return {
          cardData: newCardData,
          matchFound: newCardData.length > 0 ? true : false,
          comparePlans: compareLists,
          disablePlan: disablePlans,
          // comparePlans: [],
        };
      } else if (
        (nextProps.planTypeFilter !== "" &&
          nextProps.premiumFilter !== "" &&
          nextProps.productFilter === "") ||
        (nextProps.premiumFilter !== "" &&
          nextProps.productFilter !== "" &&
          nextProps.planTypeFilter === "") ||
        (nextProps.planTypeFilter !== "" &&
          nextProps.productFilter !== "" &&
          nextProps.premiumFilter === "")
      ) {
        newCardData = temp.filter(
          (current, i) =>
            (planType !== "" &&
              premiumType !== "" &&
              productType === "" &&
              temp[i].type.includes(planType) &&
              parseInt(temp[i].monthlyPremium) <= parseInt(premiumType)) ||
            (premiumType !== "" &&
              productType !== "" &&
              planType === "" &&
              (productType === temp[i].productName.trim() ||
                productType === temp[i]?.productCategory?.trim()) &&
              parseInt(temp[i].monthlyPremium) <= parseInt(premiumType)) ||
            (planType !== "" &&
              temp[i] &&
              temp[i].planType &&
              productType !== "" &&
              premiumType === "" &&
              temp[i].planType.trim() === planType &&
              (productType === temp[i].productName.trim() ||
                productType === temp[i]?.productCategory?.trim()))
        );
        // console.log("clsnewcarddatasub",newCardData)
        if (state.sortingVal && state.sortingVal !== "") {
          newCardData = newCardData.sort((a, b) => {
            const aPrice =
              state.dataId && Number(a[state.dataId].replace(/[^0-9.-]+/g, ""));
            const bPrice =
              state.dataId && Number(b[state.dataId].replace(/[^0-9.-]+/g, ""));
            if (state.sortingVal === "HTL") {
              return bPrice - aPrice;
            } else {
              return aPrice - bPrice;
            }
          });
        }
        return {
          cardData: newCardData,
          matchFound: newCardData.length > 0 ? true : false,
          comparePlans: compareLists,
          disablePlan: disablePlans,
          // comparePlans: [],
        };
      } else {
        //Filter product by product category only for sharp..
        // if (nextProps.customerId === "HCF0331") {
        newCardData = temp.filter(
          (current, i) =>
            current.productCategory === nextProps.productFilter ||
            (planType !== "" && temp[i]?.type?.includes(planType)) ||
            (productType !== "" &&
              productType === temp[i].productCategory.trim()) ||
            (premiumType !== "" &&
              parseInt(temp[i].monthlyPremium) <= parseInt(premiumType))
        );
        // } else {
        //   newCardData = temp.filter(
        //     (current, i) =>
        //       (planType !== "" &&
        //         temp[i].type &&
        //         temp[i].type.includes(planType)) ||
        //       (productType !== "" &&
        //         productType === temp[i].productName.trim()) ||
        //       (premiumType !== "" &&
        //         parseInt(temp[i].monthlyPremium) <= parseInt(premiumType))
        //   );
        // }
        if (state.sortingVal && state.sortingVal !== "") {
          newCardData = newCardData.sort((a, b) => {
            const aPrice =
              state.dataId && Number(a[state.dataId].replace(/[^0-9.-]+/g, ""));
            const bPrice =
              state.dataId && Number(b[state.dataId].replace(/[^0-9.-]+/g, ""));
            if (state.sortingVal === "HTL") {
              return bPrice - aPrice;
            } else {
              return aPrice - bPrice;
            }
          });
        }

        return {
          cardData: newCardData,
          matchFound: newCardData.length > 0 ? true : false,
          comparePlans: compareLists,
          disablePlan: disablePlans,
        };
      }
    } else {
      if (state.sortingVal && state.sortingVal !== "") {
        nextProps.cardDetails.sort((a, b) => {
          const aPrice =
            state.dataId && Number(a[state.dataId].replace(/[^0-9.-]+/g, ""));
          const bPrice =
            state.dataId && Number(b[state.dataId].replace(/[^0-9.-]+/g, ""));
          if (state.sortingVal === "HTL") {
            return bPrice - aPrice;
          } else {
            return aPrice - bPrice;
          }
        });
      }
      return {
        cardData: nextProps.cardDetails,
        matchFound: true,
        comparePlans: compareLists,
        disablePlan: disablePlans,
      };
    }
  }

  handleCheckedPlan = async (event) => {
    let checkedPlans = this.state.comparePlans;
    let index = checkedPlans.indexOf(event.target.value);
    if (index !== -1) {
      checkedPlans.splice(index, 1);
    } else {
      if (this.state.comparePlans.length < 3) {
        checkedPlans.push(event.target.value);
      }
    }
    await this.setState({
      comparePlans: checkedPlans,
    });
    if (this.state.comparePlans.length > 2) {
      this.setState({
        disablePlan: true,
      });
    } else if (this.state.comparePlans.length < 3) {
      this.setState({
        disablePlan: false,
      });
    }
    this.props.setStateParams(
      "selectedPlansForCompare",
      this.state.comparePlans
    );
    this.props.handleCompareList(this.state.comparePlans);
  };

  sortingFun = (event) => {
    event.preventDefault();
    const value = event.target.value;
    const dataId = event.target.options[event.target.selectedIndex].dataset.id;
    // this.state.cardData.sort((a, b) => {
    //   const aPrice = dataId && Number(a[dataId].replace(/[^0-9.-]+/g, ""));
    //   const bPrice = dataId && Number(b[dataId].replace(/[^0-9.-]+/g, ""));
    //   if (value === "HTL") {
    //     return bPrice - aPrice;
    //   } else {
    //     if (value !== "") {
    //     return aPrice - bPrice;
    //   }
    //   }
    // });
    this.setState((prevState) => ({
      ...prevState,
      sortingVal: value,
      dataId: dataId,
    }));
  };

  render() {
    let { comparePlans,cardData} = this.state;
    // cardData =
    // !cardData[9] &&
    // (cardData[0]?.productId === "0000" ||
    // cardData.length < 1) && this.props.planTypeFilter ===""
    //   ? this.props.cardDetails 
    //   : cardData;
    let productCategory = [];

    cardData.map((card) => {
      if (
        card.productCategory &&
        productCategory.indexOf(card.productCategory) === -1
      ) {
        productCategory.push(card.productCategory);
      }
      let count = cardData.filter(
        (item) => item.productCategory === card.productCategory
      ).length;
      card["count"] = count;
      return card;
    });
 
    return (
      
      <>
        <SortBy sortingFun={this.sortingFun} />
        {
        //!cardData[9] 
        !this.props.cardDetails[9]
        &&
        (
          //cardData[0]?.productId === "0000" 
          this.props.cardDetails[0]?.productId === "0000" 
          || 
        // cardData.length < 1
        this.props.cardDetails.length<1
        ) ? (
          <PlanNotFound />
        ) : (
          cardData.map(
            (cardDetail, index) =>
              cardDetail?.groupId && (
                <PlanCard
                  key={cardDetail[index]}
                  planIndex={index}
                  productFilter={this.props.productFilter}
                  cardData={cardDetail}
                  handleCheckedPlan={this.handleCheckedPlan}
                  comparePlans={comparePlans}
                  isSelected={comparePlans.indexOf(cardDetail.productId) !== -1}
                  handleSelect={this.handleSelect}
                  disablePlan={this.props.disablePlan}
                  sidebarexpanded={this.props.sidebarExpanded}
                />
              )
          )
        )}
      </>
    );
  }
}
const mapStateToProps = (state) => {
  const { selectedPlanName, stateCd } = state.webApp;
  return {
    cardDetails: state.webApp.planCardData,
    zipCode: state.webApp.zip,
    guestLoggedIn: state.login.guestLogin,
    stateName: state.webApp.state,
    countyName: state.webApp.county?.countyName
      ? state.webApp.county?.countyName
      : state.webApp.county,
    email: state.login.emailAddress,
    customerId: state.login.customerId,
    planId: state.webApp.emailPlanId,
    agentLogin: state.login.agentLoggedIn,
    ZipCodes: state.webApp.zipCodes,
    county: state.webApp.county,
    selectedPlanName,
    // county,
    stateCd,
    deeplink: state.login.deeplink,
    dpcountyName: state.login.dpcountyName,
    dpzipCode: state.login.dpzipCode,
    dpProductId: state.login.dpProductId,
    countyCode: state.webApp.countyCode,
    // customerId:state.login.customerId,
    theme: state.login.theme,
    prospectEnroll: state.webApp.prospectEnroll,
    selectedPlansForCompare: state.webApp.selectedPlansForCompare,
    //selectedPlanDetails: state.webApp.selectedPlanDetails,
    lang: state.webApp.language,
  };
};
const mapDispatchToProps = {
  getAgentIDListInPreEnrollForm,
  setFormData,
  getPlanDetails,
  planSelectionContinue,
  yearSelection,
  setStateParams,
  getPlans,
  sendEmail,
  getZipCodes,
};

export default connect(mapStateToProps, mapDispatchToProps)(PlanList);
